import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { programContent } from '../../data/program';
import { ChevronRight } from 'lucide-react';

const ProgramNav = () => {
  const { language } = useLanguage();
  const location = useLocation();
  const content = programContent[language]?.nav || programContent.en.nav;

  const navItems = [
    { path: '/program', label: content.overview },
    { path: '/program/branded-parties', label: content.brandedParties },
    { path: '/program/house', label: content.house },
    { path: '/program/shadow-cabinet', label: content.shadowCabinet },
    { path: '/program/chapters', label: content.chapters },
  ];

  const isActive = (path) => {
    if (path === '/program') {
      return location.pathname === '/program';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="bg-[#F5F0E8] border-b border-[#E8E0D4] sticky top-20 lg:top-24 z-30 print:hidden">
      <div className="container mx-auto px-4 lg:px-10">
        {/* Breadcrumb */}
        <div className="py-3 border-b border-[#E8E0D4]/50">
          <nav className="flex items-center gap-2 text-sm text-[#6B6B6B]">
            <Link to="/" className="hover:text-[#5B2D8E]">Home</Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-[#5B2D8E] font-medium">{content.program}</span>
          </nav>
        </div>
        
        {/* Sub-navigation */}
        <div className="overflow-x-auto scrollbar-hide">
          <nav className="flex items-center gap-1 py-2 min-w-max">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all ${
                  isActive(item.path)
                    ? 'bg-[#5B2D8E] text-white'
                    : 'text-[#2D2D2D] hover:bg-[#5B2D8E]/10 hover:text-[#5B2D8E]'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default ProgramNav;
